var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30ZM21.888 11.1907C22.2695 10.7003 22.1811 9.99348 21.6907 9.61203C21.2003 9.23058 20.4934 9.31893 20.112 9.80937L14.1015 17.5372C13.9678 17.709 13.7164 17.7313 13.5546 17.5857L9.75259 14.1638C9.29077 13.7482 8.57945 13.7856 8.1638 14.2475C7.74816 14.7093 7.7856 15.4206 8.24742 15.8363L12.0494 19.2581C13.1821 20.2775 14.942 20.1214 15.8775 18.9185L21.888 11.1907Z",
    fill: "#298700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/Subtract.b8484e24f688fa9067202aa56b7c2c15.svg";
export { ForwardRef as ReactComponent };